import { Capacitor } from '@capacitor/core';

/**
 * True when running inside the Capacitor native shell (the Android APK).
 * False in every browser, including the mobile-viewport web app.
 */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** Header native clients send so auth endpoints use body-transport refresh. */
export const CLIENT_PLATFORM_HEADER = 'X-Client-Platform';

/**
 * Platform tag for the X-Client-Platform header, or null on web (web sends
 * no header at all — the backend treats absence as the cookie path).
 */
export function clientPlatform(): 'android' | null {
  return isNativePlatform() && Capacitor.getPlatform() === 'android' ? 'android' : null;
}
